module.exports = __webpack_public_path__ + "img/faq5.84402cca.svg";